import { cloneDeep, defaultsDeep } from 'lodash'
import { Banner } from '../models/banner.entity'

// Initial states

const BANNER_INITIAL_STATE: Partial<Banner> = {
  name: undefined,
}

// Init

export function initBanner(banner: Partial<Banner> = {}): Banner {
  return defaultsDeep(cloneDeep(banner), BANNER_INITIAL_STATE)
}
